/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./packetLogs.vue?vue&type=template&id=bc2474f8&scoped=true"
import script from "./packetLogs.vue?vue&type=script&lang=js"
export * from "./packetLogs.vue?vue&type=script&lang=js"
import style0 from "./packetLogs.vue?vue&type=style&index=0&id=bc2474f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2474f8",
  null
  
)

export default component.exports